<template>
  <div class="link-editor">
    <draggable
      v-if="Array.isArray(links)"
      v-bind="dragOption"
      :list="links"
      :disabled="!sort"
      prevent-on-filter
      animation="200"
      filter=".ignore-drag"
      class="link-editor__list"
      :class="{'is-sort': sort}"
    >
      <transition-group>
        <div
          v-for="(item, index) in links"
          :key="item.__key"
          class="link-editor__item"
        >
          <div class="link-editor__item-wrap">
            <div class="link-editor__item-info">
              <div class="item-info-label">
                <p class="title-item-info">标签类型</p>
                <p class="title-item-info">标签名称</p>
                <p class="title-item-info">商品模式</p>
                <p class="title-item-info">列表样式</p>
                <p class="title-item-info" v-if="item.goods_model === 'normal'">商品类型</p>
              </div>
              <div class="item-info-value">
                <el-radio-group v-model="item.tabs_type">
                  <el-radio label="image">图片</el-radio>
                  <el-radio label="text">文字</el-radio>
                </el-radio-group>
                <div v-if="item.tabs_type === 'image'" class="link-editor__item-image">
                  <image-selector v-model="item.tabs_image" />
                </div>
                <el-input v-if="item.tabs_type === 'text'" v-model="item.tabs_name" size="mini" class="ignore-drag" />
                <el-radio-group v-model="item.goods_model">
                  <el-radio label="normal">常规</el-radio>
                  <el-radio label="custom">自定义</el-radio>
                </el-radio-group>
                <el-radio-group v-model="item.list_style">
                  <el-radio label="single-row">单排</el-radio>
                  <el-radio label="double-row">双排</el-radio>
                </el-radio-group>
                <el-select v-model="item.self_operated" clearable v-if="item.goods_model === 'normal'">
                  <el-option label="中欣自营" :value="1"></el-option>
                  <el-option label="中欣自营(商户入驻)" :value="4"></el-option>
                  <el-option label="电子卡" :value="8"></el-option>
                  <el-option label="欣选助农" :value="2"></el-option>
                  <el-option label="京东优选" :value="0"></el-option>
                  <el-option label="山姆优选" :value="3"></el-option>
                  <el-option label="永辉优选" :value="5"></el-option>
                  <el-option label="美团优选" :value="6"></el-option>
                  <el-option label="京东家政" :value="7"></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <template v-if="item.goods_model === 'custom'">
            <tabs-goods-selector :tabIndex="index" />
          </template>
          <i v-if="multiple" class="ri-close-circle-fill del-icon" @click="handleDeleteItem(item, index)"></i>
        </div>
      </transition-group>
    </draggable>
    <div v-if="showAdd" class="link-editor__add" @click="handleAddItem">
      <i class="ri-add-line link-editor__add-icon"></i>
      <span>添加标签</span>
    </div>
  </div>
</template>

<script>
import Draggable from 'vuedraggable'
import TabsGoodsSelector from "@/components/decor/mobile/TabsModule/TabsGoodsSelector.vue";
export default {
  name: 'TabsEditor',
  components: {TabsGoodsSelector, Draggable },
  props: {
    value: {
      type: [Array, Object, String],
      required: true
    },
    // 是否为多个
    multiple: {
      type: Boolean,
      required: false,
      default: true
    },
    // 最大个数限制
    limit: {
      type: Number,
      required: false,
      default: 1
    },
    // 是否可以排序
    sort: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      links: [],
      dragOption: {
        sort: true
      }
    }
  },
  model: { event: 'update', prop: 'value' },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        if (!this.multiple) {
          if (!newVal || !newVal.__key) newVal = this.handleMakeItem()
          this.links = [newVal]
          this.$emit('update', newVal)
        } else {
          this.links = newVal
        }
      }
    }
  },
  computed: {
    showAdd() {
      if (!this.multiple) return false
      return this.links.length < this.limit
    }
  },
  methods: {
    /**
     * 添加一项
     */
    handleAddItem() {
      if (!this.links) this.links = []
      if (this.links.length >= this.limit) {
        return this.$message.error(`超过最大个数${this.limit}个`)
      }
      this.links.push(this.handleMakeItem())
      this.$emit('update', this.links)
    },
    /**
     * 删除一项
     * @param item
     * @param index
     */
    handleDeleteItem(item, index) {
      this.links.splice(index, 1)
      this.$emit('update', this.links)
    },
    /**
     * 产生一个item
     * @returns {{tabs_type: string, __key: string, tabs_image: string, tabs_name: string}}
     */
    handleMakeItem() {
      const item = {
        __key: this.$$Foundation.uuid(),
        tabs_type: 'text',
        tabs_image: '',
        tabs_name: '标签名称',
        goods_model: 'normal',
        self_operated: 1,
        list_style: 'double-row',
        goods_list: []
      }
      return item
    }
  }
}
</script>

<style lang="scss" scoped>
.link-editor {
  &.show-image /deep/ {
    .link-selector__tag-content {
      max-width: 170px !important;
    }
  }
  .link-editor__list {
    &.is-sort .link-editor__item {
      cursor: move;
    }
    .link-editor__item {
      position: relative;
      box-sizing: border-box;
      background-color: #ffffff;
      box-shadow: 0 0 4px 0 rgba(10,42,97,0.2);
      user-select: none;
      padding: 0 12px;
      & + .link-editor__item {
        margin-top: 12px;
      }
      &:hover .del-icon {
        display: block;
      }
      .del-icon {
        display: none;
        position: absolute;
        top: -10px;
        right: -10px;
        color: #bbbbbb;
        font-size: 20px;
        background-color: #ffffff;
        border-radius: 50%;
        cursor: pointer;
      }
      .link-editor__item-wrap {
        display: flex;
        align-items: center;
        padding: 6px 0;
        border-radius: 2px;
        overflow: hidden;
      }
    }
    .link-editor__item-image {
      flex-shrink: 0;
      margin-right: 12px;
    }
    .link-editor__item-info {
      flex: 1;
      display: flex;
      .item-info-label {
        flex-shrink: 0;
        margin-right: 16px;
        .title-item-info {
          min-height: 44px;
          color: #969799;
          font-size: 14px;
          line-height: 44px;
          white-space: nowrap;
        }
      }
      .item-info-value {
        flex: 1;
        &>div {
          display: flex;
          align-items: center;
          min-height: 44px;
        }
      }
    }
  }
  .link-editor__add {
    box-sizing: border-box;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 12px;
    padding: 9px 16px;
    border: 1px solid #155bd4;
    border-radius: 2px;
    color: #155bd4;
    background-color: #ffffff;
    font-size: 14px;
    line-height: 20px;
    cursor: pointer;
    user-select: none;
    transition: all ease .2s;
    &:hover {
      background-color: rgba(#155bd4, 0.1);
    }
    .link-editor__add-icon {
      margin-right: 5px;
    }
  }
  /deep/ {
    .link-selector__tag-content {
      max-width: 230px !important;
    }
  }
}
</style>
